<template>
  <page-loader>
    <v-container>
      <v-row>
        <v-col>
          <filter-accordion
            :loading="isLoading"
            :query-count="$_queryHandler_numberOfQueries"
            :query-changed="$_queryHandler_hasQueryChanged"
            @clear-filters="$_queryHandler_resetFilters"
          >
            <template #search>
              <search-input v-model="query.searchTerm" hide-details clearable />
            </template>
            <template #default>
              <v-row>
                <v-col sm="4">
                  <select-list
                    v-model="query.params.supports_amp"
                    :items="[
                      { key: 'Yes', value: true },
                      { key: 'No', value: false },
                    ]"
                    label="Supports AMP"
                    clearable
                    hide-details
                  />
                </v-col>
              </v-row>
            </template>
            <template #content>
              <data-table
                :footer-props="{ 'items-per-page-options': perPageOptions }"
                :headers="tableHeaders"
                :items="shortcodes"
                :items-per-page="pagination.perPage"
                :page="pagination.currentPage"
                :route="{ name: 'shortcodes.edit', params: ['id'] }"
                :server-items-length="pagination.total"
                disable-sort
                @pagination="$_queryHandler_onUpdatePagination"
              >
                <template #item.supports_amp="{ item }">
                  <v-icon :color="item.script_amp ? 'success' : 'error'">{{
                    item.script_amp ? 'check_circle' : 'cancel'
                  }}</v-icon>
                </template>
              </data-table>
            </template>
          </filter-accordion>
        </v-col>
      </v-row>
    </v-container>
    <fab-create v-if="isPermittedTo('create')" type="Shortcode" @click="onCreate" />
  </page-loader>
</template>

<script>
// Helpers
import { mapGetters, mapMutations } from 'vuex'
// Components
import DataTable from '@/components/data-table'
import FabCreate from '@/components/fab-create'
import FilterAccordion from '@/components/filter-accordion'
import PageLoader from '@/components/page-loader'
import SearchInput from '@/components/forms/search-input'
import SelectList from '@/components/forms/select-list'
// Mixins
import PermissionsHandler from '@/mixins/permissions-handler'
import QueryParamsHandler from '@/mixins/query-params-handler'
// Services
import { shortcodes } from '@/services/offers'

export default {
  name: 'ShortcodeManagement',
  components: {
    DataTable,
    FabCreate,
    FilterAccordion,
    PageLoader,
    SearchInput,
    SelectList,
  },
  mixins: [PermissionsHandler, QueryParamsHandler],
  data: () => ({
    isLoading: false,
    shortcodes: [],
    pagination: { perPage: 30 },
    perPageOptions: [15, 30, 50, 100],
    queriesDefined: ['supports_amp'],
    queryTypes: { supports_amp: 'boolean' },
    showOfferCreateModal: false,
    tableHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Description', value: 'description' },
      { text: 'Supports AMP', value: 'supports_amp', align: 'center' },
    ],
  }),
  computed: {
    ...mapGetters('general', ['hasPageErrors', 'isPageLoading']),
  },
  methods: {
    ...mapMutations('general', ['setPageLoading', 'setPageErrors']),
    async getShortcodes() {
      this.isLoading = true
      const { perPage, currentPage: page } = this.pagination

      try {
        const search = this.query.searchTerm
        const supportsAmp = this.query.params.supports_amp
        const supportsAmpFilter =
          supportsAmp === true ? { script_ampIsSet: true } : supportsAmp === false ? { script_ampNotSet: true } : {}
        const { data = [], pagination: { total } = {} } = await shortcodes.getFiltered({
          search,
          page,
          perPage,
          filters: supportsAmpFilter,
        })
        this.shortcodes = data
        this.pagination.total = total
      } catch (error) {
        this.setPageErrors(true)
        this.$notify({
          type: 'error',
          text: 'Unable to retrieve shortcodes',
        })
      }

      this.setPageLoading(false)
      this.isLoading = false
    },
    async handleQueryUpdate() {
      await this.getShortcodes()
    },
    onCreate() {
      this.$router.push({ name: 'shortcodes.create' })
    },
  },
}
</script>
